import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AdminAuthGuard } from "./service/admin-auth.guard";
import { UserAuthGuard } from "./service/user-auth.guard";
import { AuthGuardService } from "./service/auth-guard.service";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";

const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "welcome" },
  { path: "isuite", pathMatch: "full", redirectTo: "welcome" },
  { path: "dev", pathMatch: "full", redirectTo: "welcome" },  
  { path: "qa", pathMatch: "full", redirectTo: "welcome" },
  { path: "eisuite", pathMatch: "full", redirectTo: "welcome" },
  {
    path: "welcome",
    loadChildren: "./modules/welcome/welcome.module#WelcomeModule",
  },
  {
    path: "helpdesk",
    loadChildren: "./modules/help-desk/help-desk.module#HelpDeskModule",
  },
  { path: "home", loadChildren: "./modules/home/home.module#HomeModule" },
  {
    path: "users",
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    loadChildren: "./modules/users/users.module#UsersModule",
  },
  {
    path: "databasemgmt",
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    loadChildren:
      "./modules/databasemgmt/databasemgmt.module#DatabasemgmtModule",
  },
  {
    path: "messageboard",
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    loadChildren:
      "./modules/messageboard/messageboard.module#MessageboardModule",
  },
  {
    path: "incidents",
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    loadChildren: "./modules/incidents/incidents.module#IncidentsModule",
  },
      //Wild Card Route for 404 request
    { path: '**', component: PageNotFoundComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true})], // <-- debugging purposes only)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const routingComponents = [];
